import { Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { UserPlus, RefreshCw, ArrowRight } from 'lucide-react';

export default function EnrollmentLandingPage() {
  const { language } = useLanguage();
  const [searchParams] = useSearchParams();
  const tier = searchParams.get('tier');
  const tierParam = tier ? `?tier=${tier}` : '';

  const cards = [
    {
      icon: UserPlus,
      titleES: 'Nueva Inscripción',
      titleEN: 'New Enrollment',
      descES: 'Primera vez en Colegio ARCE. Todos los nuevos alumnos deben realizar una evaluación de nivel antes de completar la inscripción.',
      descEN: 'First time at Colegio ARCE. All new students must complete a level assessment before finalizing enrollment.',
      link: `/enrollment/new${tierParam}`,
      color: '#E63946',
      testId: 'new-enrollment-card'
    },
    {
      icon: RefreshCw,
      titleES: 'Reinscripción',
      titleEN: 'Re-enrollment',
      descES: 'Ya eres alumno de Colegio ARCE y deseas renovar tu matrícula para el próximo año escolar.',
      descEN: 'Already a Colegio ARCE student and want to renew your enrollment for the next school year.',
      link: `/enrollment/reenroll${tierParam}`,
      color: '#007AFF',
      testId: 'reenroll-card'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <Navbar />
      <SEOHead
        titleES="Inscríbete — Colegio ARCE"
        titleEN="Enroll — Colegio ARCE"
        descES="Inscribe a tu hijo en Colegio ARCE. Clases virtuales de español para niños."
        descEN="Enroll your child at Colegio ARCE. Virtual Spanish classes for children."
        path="/enrollment"
      />
      <main className="pt-40 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl font-semibold text-[#1D1D1F] mb-4" data-testid="enrollment-landing-title">
              {language === 'es' ? 'Inscripciones' : 'Enrollment'}
            </h1>
            <p className="text-base text-[#86868B] max-w-lg mx-auto">
              {language === 'es'
                ? 'Selecciona el tipo de inscripción que necesitas.'
                : 'Select the type of enrollment you need.'}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {cards.map((card) => (
              <Link
                key={card.testId}
                to={card.link}
                className="group card-apple p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
                data-testid={card.testId}
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6"
                  style={{ backgroundColor: `${card.color}10` }}
                >
                  <card.icon className="h-7 w-7" style={{ color: card.color }} />
                </div>
                <h2 className="text-xl font-semibold text-[#1D1D1F] mb-3">
                  {language === 'es' ? card.titleES : card.titleEN}
                </h2>
                <p className="text-sm text-[#86868B] leading-relaxed flex-1">
                  {language === 'es' ? card.descES : card.descEN}
                </p>
                <div className="flex items-center gap-2 mt-6 font-medium text-sm" style={{ color: card.color }}>
                  {language === 'es' ? 'Continuar' : 'Continue'}
                  <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
